import type { AppRegion } from '@/entities/region'

// API base URLs by region
export const API_BASE_URLS: Record<AppRegion, string> = {
  au: import.meta.env.VITE_OVERRIDE_API_URL
    || import.meta.env.VITE_OVERRIDE_AU_API_URL
    || 'https://au1-screens-core.bluedot.io',
  eu: import.meta.env.VITE_OVERRIDE_API_URL
    || import.meta.env.VITE_OVERRIDE_EU_API_URL
    || 'https://eu1-screens-core.bluedot.io',
  us: import.meta.env.VITE_OVERRIDE_API_URL
    || import.meta.env.VITE_OVERRIDE_US_API_URL
    || 'https://us1-screens-core.bluedot.io',
}

export const DEFAULT_REGION: AppRegion = 'au'
